<template>
  <div class="fy-calendar">
    <input
      :placeholder="placeholder"
      :readonly="is_readonly"
      @click="openByDrop($event)"
      type="text"
      v-model="currentValue"
    >
    <div class="calendar-dropdown" v-if="show">
      <!-- :range="range" -->
      <calendar
        :begin="begin"
        :disabled="disabled"
        :end="end"
        :events="events"
        :lunar="lunar"
        :multi="multi"
        :range="range"
        :value="date_value"
        :zero="zero"
        @select="select"
      ></calendar>
    </div>
  </div>
</template>

<script>
/**
 * 使用例子：
 *  <fy-form-item label="日期选择">
        <fy-input-date :calendar_prop="calendar" v-model="birthday" placeholder="请选择生日"></fy-input-date>
    </fy-form-item>

    birthday：0  //birthday的格式为时间戳（数值），0代表为空
    calendar: {
        show: false,
        zero: true,
        date_value: [2018, 12, 13], //默认日期
        lunar: true, //显示农历
     },
 */
import calendar from '@/components/calendar/calendar.vue'
import util from '../utils/util.js'
export default {
  name: 'FyInputDate',
  componentName: 'FyInputDate',
  mixins: [util], //这些混入实例对象可以像正常的实例对象一样包含选项（可以直接this.*使用混入对象中的方法）
  inject: {
    //获取父元素的provide中的值
    fyForm: {
      default: ''
    },
    fyFormItem: {
      default: ''
    }
  },
  components: {
    calendar
  },
  props: {
    placeholder: {
      type: String,
      default: '请选择日期'
    },
    is_readonly: {
      type: Boolean,
      default: true
    },

    //为了简化使用组件时属性的传递，将calendar组件中的props全部放在calendar_prop对象中
    calendar_prop: {},

    //时间戳（数值）格式,没有默认值传0
    value: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      currentValue: this.timestampToDate(this.value),

      //以下数据全部封装到calendar中传入
      show: false,
      //选择了日期后执行的事件
      select: value => {
        this.show = false
        this.date_value = value
        this.currentValue = value.join('-')
      },

      // :value Array default:[] * 日历的默认值
      // :begin Array default:[] * 限制开始选择日期
      // :end Array default:[] * 限制结束选择日期
      // :range Bool default:false * 您可以选择一个时间段
      // :zero Bool default:false * 是否小于10补零
      // :lunar Bool default:false * 显示中国农历
      // :weeks Array * 根据系统语言的变化或自定义
      // :months Array * 根据系统语言的变化或自定义
      // :events Object * 自定义日历事件
      //以下是calendar组件中的属性
      // 多选模式
      multi: false,
      // 范围模式
      range: false,
      // 默认日期
      date_value: [],
      // 开始选择日期
      begin: [],
      // 结束选择日期
      end: [],
      // 是否小于10补零
      zero: false,
      // 屏蔽的日期
      disabled: [],
      // 是否显示农历
      lunar: false,
      // 自定义事件
      events: {}
    }
  },
  mounted () {
    this.dispatch('FyFormItem', 'formItem.addChildVc', [this]) //发送添加formitem对象的信息
    for (var key in this.calendar_prop) {
      if (this.calendar_prop[key]) {
        this[key] = this.calendar_prop[key]
      }
    }
  },
  watch: {
    value (value) {
      this.setCurrentValue(this.value)
    },
    currentValue (value) {
      this.$emit('input', this.dateToTimestamp(value))
      this.dispatch('FyFormItem', 'el.form.change', [
        this.dateToTimestamp(value)
      ])
    }
  },
  computed: {},
  methods: {
    // onfocus(e) {
    //   this.show = true
    // },
    // onblur(e) {
    //   window.setTimeout(() => {
    //     this.show = false
    //   }, 100)
    // },
    // 设置calendar组件的显示和隐藏
    openByDrop (e) {
      const vue = this
      vue.show = true
      // e.stopPropagation()
      // window.setTimeout(() => {
      // document.onclick = function(e) {
      //   console.log(vue.show)
      //   vue.show = false
      //   document.removeEventListener('click', () => {}, false)
      // }
      document.addEventListener(
        'click',
        e => {
          e.stopPropagation()
          if (vue.show) {
            vue.show = false
            this.dispatch('FyFormItem', 'el.form.change', [
              this.dateToTimestamp(this.currentValue)
            ])
          }
          document.removeEventListener('click', () => { }, false)
        },
        false
      )
      // }, 1000)
      e.stopPropagation()
    },
    setCurrentValue (value) {
      if (value === this.currentValue) return // 如果新旧值一致直接返回
      this.currentValue = this.timestampToDate(this.value) // 改变当前值
    },
    resetField () {
      this.currentValue = ''
    },
    //日期转时间戳
    dateToTimestamp (value) {
      const reg = /^(\d{4})-(\d{2})-(\d{2})$/
      if (!reg.test(value)) {
        return 0
      } else {
        return new Date(value).getTime()
      }
    },
    //时间戳转日期
    timestampToDate (value) {
      if (value == 0 || value.constructor != Number) {
        return ''
      }
      if (value.toString().length <= 10) {
        value = value * 1000
      }
      const date = new Date(value)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      var d = date.getDate()
      d = d < 10 ? '0' + d : d
      const s = y + '-' + m + '-' + d
      return y + '-' + m + '-' + d
    }
  }
}
</script>

<style scoped>
@import '../../assets/css/components/form/form.css';
</style>



// WEBPACK FOOTER //
// src/components/form/inputDate.vue